module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.block]
  }, [_vm._l((_vm.articles), function(article) {
    return _c('div', [(article) ? _c("flexBlock", {
      tag: "component",
      attrs: {
        "data": article
      }
    }) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.articleIndex > 0) ? _c('button-block', {
    ref: "moreButton",
    class: [_vm.block + '-button'],
    attrs: {
      "blockModifiers": ['hoverHightlight'],
      "text": _vm.data.buttonText
    },
    nativeOn: {
      "click": function($event) {
        _vm.moreButtonClicked()
      }
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77d287f5","buble":{"objectAssign":"Object.assign"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/combinedBlocks/ArticleLoader.vue
// module id = 468
// module chunks = 0